module.exports = __webpack_public_path__ + "static/media/Montserrat-Thin.b60b82f5.ttf";